module.exports = __webpack_public_path__ + "media/images/referfriend-7434ebb96618854571983693795a37be.svg";